import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface ITextPropertyEditable {
  text(): IPropertyEditable<string>;
}

export function instanceOfITextPropertyEditable(instance: any): instance is ITextPropertyEditable {
  return instance
      && instance.text
      && instanceOfIPropertyEditable<string>(instance.text());
}
